import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	go: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	back: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	backRovo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	go: {
		id: 'atlassian-intelligence.search-field.shortcut-buttons.go',
		defaultMessage: 'Go',
		description: 'Label for the "Go" button to run a new search',
	},
	back: {
		id: 'atlassian-intelligence.search-field.shortcut-buttons.back',
		defaultMessage: 'Back - Exit Atlassian Intelligence',
		description: 'Label for the "Back" button to exit a search',
	},
	backRovo: {
		id: 'atlassian-intelligence.search-field.shortcut-buttons.back-rovo',
		defaultMessage: 'Back - Exit Rovo',
		description: 'Label for the "Back" button to exit a search (Rovo variant)',
	},
});
export default messages;
